import React from "react";
import { object } from "prop-types";

import "./old-stories-message.m.css";

const OldStoryMessage = ({ story }) => {
  if (!story) {
    return null;
  }

  const publishedYear = new Date(story["published-at"]).getFullYear();
  return publishedYear < 2006 ? <p styleName="message">This story was published before 2006</p> : null;
};

OldStoryMessage.propTypes = {
  story: object,
};

export { OldStoryMessage };
